/**
 * @desc 修改邮件回复信息
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(
  ticketId: string | number,
  body: defs.crm.TicketInfoRequestDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/crm/ticket/${ticketId}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
